'use client';

import { usePathname } from 'next/navigation';

import useUser from '@/utils/hooks/swr/useUser';

import { GIVEAWAY_PICKER, GIVEAWAY_PICKER_RESULTS } from '@/lib/routes/publicRoutes';

import { AdobeExpress } from '@/components/tools/AdobeExpress';
import { DataDogErrorMonitoring } from '@/components/tools/DataDog/DataDogErrorMonitoring';
import { DataDogLogCollection } from '@/components/tools/DataDog/DataDogLogCollection';
import DeleteOldCookies from '@/components/tools/DeleteOldCookies';
import { FlagsmithUserIdentifier } from '@/components/tools/FlagsmithUserIdentifier';
import GoogleTagManager from '@/components/tools/GoogleTagManager';
import HubSpotIdentification from '@/components/tools/HubSpotIdentification';
import { IsUserLoggedIn } from '@/components/tools/IsUserLoggedIn';
import { MixPanelInitialize } from '@/components/tools/MixPanel/MixPanelInitialize';

const AppRouterTools = () => {
    const pathname = usePathname();
    const { user } = useUser({ revalidateOnMount: false });

    // Remove locale prefix from pathname for comparison
    const pathWithoutLocale = pathname.replace(/^\/(en|fr|es)(?=\/|$)/, '') || '/';

    if (pathWithoutLocale === GIVEAWAY_PICKER || pathWithoutLocale === GIVEAWAY_PICKER_RESULTS) {
        return (
            <>
                <DataDogErrorMonitoring />
                <DataDogLogCollection />
            </>
        );
    }

    return (
        <>
            <GoogleTagManager />
            <DataDogErrorMonitoring />
            <DataDogLogCollection />
            <AdobeExpress />
            {user ? <MixPanelInitialize /> : null}
            <IsUserLoggedIn />
            <FlagsmithUserIdentifier />
            {/* This is a custom script to delete old cookies from user's browsers => remove this after a while : https://iconosquare.atlassian.net/browse/ICO-2059*/}
            <DeleteOldCookies />
            <HubSpotIdentification />
        </>
    );
};

export default AppRouterTools;
